import type { ThreadConfig } from "../types";
import type { Input } from "@/workflow_api/types/workflow";

export const serializeMultiThreadNode = (threads: ThreadConfig[]): Input => {
  return threads.map((thread, index) => ({
    id: thread.id,
    name: `thread_${index + 1}`,
    value: thread.label,
    type: "STRING",
    order: index + 1,
  }));
};

export const deserializeMultiThreadNode = (
  inputs: Input,
): ThreadConfig[] | null => {
  if (!inputs || inputs.length === 0) {
    return null;
  }

  return inputs
    .filter((input) => input.name?.startsWith("thread_"))
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .map((input) => ({
      id: input.id || "",
      label: (input.value as string) || "",
    }));
};

export const getMultiThreadConfigFromInputs = (inputs: Input) => {
  const syncPolicyInput = inputs.find((input) => input.name === "sync_policy");
  const errorPolicyInput = inputs.find(
    (input) => input.name === "error_policy",
  );
  const retryCountInput = inputs.find((input) => input.name === "retry_count");

  return {
    syncPolicy:
      (syncPolicyInput?.value as "wait_all" | "first_response") || "wait_all",
    errorPolicy:
      (errorPolicyInput?.value as
        | "fail_all"
        | "continue_remaining"
        | "retry_failed") || "fail_all",
    retryCount: (retryCountInput?.value as number) || 0,
  };
};
